module.exports = __webpack_public_path__ + "img/wu.3aa5b517.png";